import { useData } from '../../../../contexts/data-context/use-data';
import { LoadingSection } from '../../../../design-system/loading/loading';
import { Stack } from '../../../../design-system/stack/stack';
import CashFlowMetrics from './cash-flow-metrics';
import { CurrentCashWrapper } from './current-cash-wrapper';
import { MoneyMovementChartWrapper } from './money-movement-wrapper';
import { RecentTransactionsWrapper } from './recent-transactions-wrapper';
import { RunwayChartWrapper } from './runway-chart-wrapper';

const CashFlowWrapper = () => {
  const { data, isLoading, error } = useData();

  if (isLoading) {
    return <LoadingSection text="Creating your cash flow report..." />;
  }

  if (!data || error) {
    return <div>No data</div>;
  }

  const { accounts } = data;

  return (
    <Stack className="mx-32 mb-10" space={10}>
      <CashFlowMetrics accounts={accounts} baseCurrency={data.baseCurrency} />
      <RunwayChartWrapper accounts={accounts} baseCurrency={data.baseCurrency} />
      <CurrentCashWrapper accounts={accounts} baseCurrency={data.baseCurrency} />
      <MoneyMovementChartWrapper accounts={accounts} baseCurrency={data.baseCurrency} />
      <RecentTransactionsWrapper accounts={accounts} />
    </Stack>
  );
};

export default CashFlowWrapper;
